import { __awaiter } from "tslib";
import { useDispatch } from 'react-redux';
import { useRouter } from '@shared/router';
import { useRefund } from '../providers/RefundProvider';
import { setRefundLoading } from '../model/loading/actions';
export const useBackToOrder = (needUpdate = false) => {
    const router = useRouter();
    const dispatch = useDispatch();
    const { updateOrder } = useRefund();
    const onBackToOrder = () => __awaiter(void 0, void 0, void 0, function* () {
        if (needUpdate) {
            try {
                dispatch(setRefundLoading('updateOrder', true));
                yield updateOrder();
            }
            finally {
                dispatch(setRefundLoading('updateOrder', false));
            }
        }
        router.navigate('/order');
    });
    return { onBackToOrder };
};
